import { render, staticRenderFns } from "./alert_index.vue?vue&type=template&id=c473a830&"
import script from "./alert_index.vue?vue&type=script&lang=js&"
export * from "./alert_index.vue?vue&type=script&lang=js&"
import style0 from "./alert_index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports